module.exports = __webpack_public_path__ + "img/cancelado.53673722.png";